module.exports = __webpack_public_path__ + "static/too-small-1589f4fed26b8bd3370c4cf9e5150f67.jpg";